import { gql } from '@apollo/client'
import React from 'react'

import { minicrudsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useMinicrudState = () => React.useContext(Context)
export const useMinicrud = () => useMinicrudState()?.minicrud

const QUERY = gql`
  query Minicrud($id: ID) {
    minicrud(id: $id, filter: { includeDeleted: true }) {
      id
      name
      entity
    }
  }
`

const MinicrudLoader = ({ children }) => {
  const id = useModalData()?.id

  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: minicrudsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default MinicrudLoader
